import dayjs from "dayjs";
import type { Dayjs } from "dayjs";
import type { SDate } from "@/services/api/entities/person/types";
import { DATE_FORMAT } from "../constants";

export const isOverDueDate = ({ dueDate }: { dueDate: string }): boolean => {
  return dayjs().diff(dayjs(dueDate, DATE_FORMAT), "day") >= 1;
};

export const getDatePickerDefaultValueDate = (date?: string) => {
  const formatted = dayjs(date, DATE_FORMAT);
  return formatted.isValid() ? formatted : null;
};

export const compareDates = ({
  firstDate,
  secondDate,
}: {
  firstDate: string;
  secondDate: string;
}): number => {
  return dayjs(firstDate, DATE_FORMAT).diff(dayjs(secondDate, DATE_FORMAT));
};

export const transformDateFormat = ({
  date,
  inputFormat,
  outputFormat,
}: {
  date: string;
  inputFormat: string;
  outputFormat: string;
}): string => {
  return dayjs(date, inputFormat).format(outputFormat);
};

export const compareDatesByDay = ({
  firstDate,
  secondDate,
}: {
  firstDate: string;
  secondDate: string;
}): boolean => {
  const firstDateDayjs = dayjs(firstDate, DATE_FORMAT);
  const secondDateDayjs = dayjs(secondDate, DATE_FORMAT);
  if (!firstDate || !secondDate) return false;
  return firstDateDayjs.diff(secondDateDayjs, "day") >= 1;
};

export const formatDate = (date: Date) => {
  const formatted = dayjs(date, DATE_FORMAT);
  const withOutYearFormatted = dayjs(date, "DD-MM");
  if (formatted?.isValid()) {
    return formatted;
  }
  if (withOutYearFormatted?.isValid()) {
    return withOutYearFormatted;
  }
  return null;
};

export const formatDayJs = (date: Dayjs): string => {
  return date?.format(DATE_FORMAT);
};

export const transformSDateToString = (SDate?: SDate): string => {
  const getStringifyDate = (date?: number | null) => {
    if (!date) return "";
    if (Number(date) > 9) {
      return date;
    }
    return `0${date}`;
  };

  const day = getStringifyDate(SDate?.day);
  const month = getStringifyDate(SDate?.month);
  const year = SDate?.year;
  if (day && month && year) {
    return `${day}-${month}-${year}`;
  }
  if (day && month) {
    return `${day}-${month}`;
  }
  if (!day && !month && !year) return "";
  return "";
};

export const transformStringToSDate = (date: string): SDate => {
  const datum = date.split("-");
  const day = Number(datum[0]);
  const month = Number(datum[1]);
  const year = Number(datum[2]);

  return {
    day: day || null,
    month: month || null,
    year: year || null,
  };
};

export const formatStringToDayJs = (date: string) => {
  return dayjs(date, DATE_FORMAT);
};

export function getCurrentDate(): string;
export function getCurrentDate(isDayjs: true): Dayjs;
export function getCurrentDate(isDayjs?: boolean): string | Dayjs {
  const currentDate = dayjs();
  if (isDayjs) return currentDate;
  return currentDate.format(DATE_FORMAT);
}

export const isUrgentDate = ({ dueDate }: { dueDate: Date | number | string }): boolean => {
  return dayjs().diff(dayjs(dueDate, DATE_FORMAT), "day") >= 0;
};

export const isCloseToDueDate = ({ dueDate }: { dueDate: Date | number | string }): boolean => {
  return dayjs().diff(dayjs(dueDate, DATE_FORMAT), "day") >= -1;
};
